import { SyntaxError } from "./errors.js";
import { abs } from "./functions/abs.js";
import { atn } from "./functions/atn.js";
import { cos } from "./functions/cos.js";
import { tan } from "./functions/tan.js";
import { sin } from "./functions/sin.js";
import { log } from "./functions/log.js";
import { exp } from "./functions/exp.js";
import { rnd } from "./functions/rnd.js";
import { val } from "./functions/val.js";
import { str } from "./functions/str.js";
import { sqr } from "./functions/sqr.js";
import { spc } from "./functions/spc.js";
import { len } from "./functions/len.js";
import { int } from "./functions/int.js";

const processUnsupportedFunction = async () => await new SyntaxError().handleError();
const unsupportedFunction = processUnsupportedFunction;

export const functions = {
    ABS:    async(args) => await abs(args),
    AND:    unsupportedFunction,
    ASC:    unsupportedFunction,
    ATN:    async(args) => await atn(args),
    CHR$:   unsupportedFunction,
    COS:    async(args) => await cos(args),
    EXP:    async(args) => await exp(args),
    FN:     unsupportedFunction,
    FRE:    unsupportedFunction,
    INT:    async(args) => int(args),
    LEFT$:  unsupportedFunction,
    LEN:    async(args) => len(args),
    LOG:    async(args) => log(args),
    MID$:   unsupportedFunction,
    NOT:    unsupportedFunction,
    OR:     unsupportedFunction,
    PEEK:   unsupportedFunction,
    POS:    unsupportedFunction,
    RIGHT$: unsupportedFunction,
    RND:    async(args) => await rnd(args),
    SGN:    unsupportedFunction,
    SIN:    async(args) => await sin(args),
    SPC:    async(args) => await spc(args),
    SQR:    async(args) => await sqr(args),
    STR$:   async(args) => await str(args),
    TAB:    unsupportedFunction,
    TAN:    async(args) => await tan(args),
    USR:    unsupportedFunction,
    VAL:    async(args) => await val(args)
};

export const isSupportedFunction = (functionName) => functions.hasOwnProperty(functionName) && functions[functionName] !== unsupportedFunction;